import { ErrorHolder, Warning, Close } from "./styles";
import { SubText } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var initializeErrorNotification = function initializeErrorNotification(errorMessage, open, close) {
  var popupEvent = new CustomEvent(open, {
    detail: /*#__PURE__*/_jsxs(ErrorHolder, {
      children: [/*#__PURE__*/_jsx(Warning, {}), /*#__PURE__*/_jsx(SubText, {
        inverted: true,
        children: errorMessage
      }), /*#__PURE__*/_jsx(Close, {
        onClick: function onClick() {
          return window.dispatchEvent(new CustomEvent(close));
        }
      })]
    })
  });
  window.dispatchEvent(popupEvent);
};